<template>
  <div>
    <vx-card title="پروفایل" class="mb-base">
      <div class="vx-row">
        <div class="vx-col" id="avatar-col">
          <div class="img-container mb-4">
            <img v-if="$store.state.AppActiveUser.photoURL" :src="$store.state.AppActiveUser.photoURL"
                 class="rounded h-24 w-24"/>
            <img v-else :src="require('@/assets/images/avatar.png')" class="rounded h-24 w-24"/>
          </div>
        </div>

        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold ">نام</td>
              <td class="pl-5" v-text="user.firstName"></td>
            </tr>
            <tr>
              <td class="font-semibold">نام خانوادگی</td>
              <td class="pl-5">{{ user.lastName }}</td>
            </tr>
            <tr>
              <td class="font-semibold">نام کاربری</td>
              <td class="pl-5">{{ user.userName }}</td>
            </tr>
          </table>
        </div>

        <div class="vx-col flex-1 mt-4" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold">موبایل</td>
              <td class="pl-5">{{ user.cellPhoneNumber }}</td>
            </tr>
            <tr>
              <td class="font-semibold">تلفن ثابت</td>
              <td class="pl-5">{{ user.homePhoneNumber || '-----------' }}</td>
            </tr>
            <tr>
              <td class="font-semibold">آدرس</td>
              <td class="pl-5">{{ user.homeLocationText }}</td>
            </tr>
          </table>
        </div>
        <div class="vx-col w-full flex" id="account-manage-buttons">
          <vs-button  icon-pack="feather" icon="icon-edit" @click="editing=!editing">ویرایش
            پروفایل
          </vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-3" v-if="editing" title="ویرایش پروفایل">
      <avatar-uploader :user-id="$store.state.AppActiveUser.id" context="user"
                       :image="$store.state.AppActiveUser.photoURL||''"></avatar-uploader>
      <!-- form-student used for (STUDENT | MODERATOR | DRIVER)  -->
      <form-student @lock="lockChanged" v-if="user" :data="user" @save="saveProfile"></form-student>
    </vx-card>
  </div>
</template>

<script>
  import FormStudent from "../students/FormStudent";
  import AvatarUploader from "./components/AvatarUploader";
  import Vue from "vue";

  export default {
    name: "ShowProfile",
    components: {AvatarUploader, FormStudent},
    data() {
      return {
        user: '',
        editing: false
      }
    },
    mounted() {
      this.$store.dispatch('getUser', {
        role: 'all',
        userId: Number(this.$store.state.AppActiveUser.id)
      }).then(user => {
        this.user = user
      })
    },
    methods: {
      saveProfile(user) {
        this.$store.dispatch('saveProfile', user)
          .then(() => {
            this.$vs.notify({title: 'پروفایل ذخیره شد', text: '', color: 'success', position: 'top-center'})
            this.user = Object.assign({}, user)
          })
          .catch((err) => {
            console.log(err)
          })
      },
      lockChanged(user) {
        this.user.locked = Number(user.locked)
      }
    }
  }
</script>

<style scoped>
  .vs-input {
    width: auto !important;
    padding: 0 5px;
  }
</style>
